<template>
    <v-container>
        <v-row>
            <v-col class="ma-0 pa-0 mb-4" cols="4">
                <v-text-field label="Cerca" v-model="search" />
            </v-col>
            <v-checkbox label="Raggruppa per agente" v-model="raggruppa" v-on:change="caricaDati()" color="#EE1453" />
            <v-spacer />
            <v-col cols="1" class="border-style mb-0 pb-0">
                Totale {{ anno - 1 }}: {{ formatNumber(totAnnoPrec) }}
            </v-col>
            <v-col cols="1" class="border-style mb-0 pb-0"
                :class="totAnnoAtt < totAnnoPrec ? 'peach-puff' : totAnnoAtt > totAnnoPrec ? 'green-yellow' : ''">
                Totale {{ anno }}: {{ formatNumber(totAnnoAtt) }}
            </v-col>
            <v-col cols="1" class="border-style mb-0 pb-0"
                :class="totAnnoAtt < totAnnoPrec ? 'peach-puff' : totAnnoAtt > totAnnoPrec ? 'green-yellow' : ''">
                Variazione:
                <span :class="variation < 0 ? 'peach-puff' : variation > 0 ? 'green-yellow' : ''">
                    {{ variation }}%
                </span>
            </v-col>
        </v-row>
        <v-col class="ma-0 pa-0 mt-4">
            <v-data-table dense :items="dati" :headers="headers" :items-per-page="-1" fixed-header height="60vh"
                mobile-breakpoint="0" no-data-text="Nessun dato disponibile" :search="search">
                <!-- Slot per personalizzare l'intera riga -->
                <template v-slot:item="row">
                    <tr style="max-height: 44px !important; height: 44px !important;">
                        <td class="pl-1 pr-1">{{ row.item.CLRAGSOC }}</td>
                        <td class="pl-1 pr-1">{{ row.item.ANNOMAGE }}</td>
                        <td class="text-right pl-2 pr-2">{{ formatNumber(row.item.Trimestre_1_Precedente) }}</td>
                        <td class="pl-0 pr-1" :class="['light-yellow', 'text-center']">
                            {{ row.item.Inc1 }}
                        </td>
                        <td class="text-right pl-2 pr-2">{{ formatNumber(row.item.Trimestre_2_Precedente) }}</td>
                        <!-- Incasso 2 -->
                        <td class="pl-0 pr-1" :class="['text-center', getCellClass(row.item.Inc2)]">
                            {{ row.item.Inc2 }}
                        </td>
                        <!-- Trimestre 3 Precedente -->
                        <td class="text-right pl-2 pr-2">{{ formatNumber(row.item.Trimestre_3_Precedente) }}</td>
                        <!-- Incasso 3 -->
                        <td class="pl-0 pr-1" :class="['text-center', getCellClass(row.item.Inc3)]">
                            {{ row.item.Inc3 }}
                        </td>
                        <!-- Trimestre 4 Precedente -->
                        <td class="text-right pl-2 pr-2">{{ formatNumber(row.item.Trimestre_4_Precedente) }}</td>
                        <!-- Incasso 4 -->
                        <td class="pl-0 pr-1" :class="['text-center', getCellClass(row.item.Inc4)]">
                            {{ row.item.Inc4 }}
                        </td>
                        <!-- Trimestre 1 Attuale -->
                        <td class="text-right pl-2 pr-2">{{ formatNumber(row.item.Trimestre_1_Attuale) }}</td>
                        <!-- Incasso 5 -->
                        <td class="pl-0 pr-1" :class="['text-center', getCellClass(row.item.Inc5)]">
                            {{ row.item.Inc5 }}
                        </td>
                        <!-- Trimestre 2 Attuale -->
                        <td class="text-right pl-2 pr-2">{{ formatNumber(row.item.Trimestre_2_Attuale) }}</td>
                        <!-- Incasso 6 -->
                        <td class="pl-0 pr-1" :class="['text-center', getCellClass(row.item.Inc6)]">
                            {{ row.item.Inc6 }}
                        </td>
                        <!-- Trimestre 3 Attuale -->
                        <td class="text-right pl-2 pr-2">{{ formatNumber(row.item.Trimestre_3_Attuale) }}</td>
                        <!-- Incasso 7 -->
                        <td class="pl-0 pr-1" :class="['text-center', getCellClass(row.item.Inc7)]">
                            {{ row.item.Inc7 }}
                        </td>
                        <!-- Trimestre 4 Attuale -->
                        <td class="text-right pl-2 pr-2">{{ formatNumber(row.item.Trimestre_4_Attuale) }}</td>
                        <!-- Incasso 8 -->
                        <td class="pl-0 pr-1" :class="['text-center', getCellClass(row.item.Inc8)]">
                            {{ row.item.Inc8 }}
                        </td>
                        <td class="text-right pl-0 pr-1" style="border-left: 2px solid black;">
                            {{ formatNumber(row.item.TotaleAnnoPrec) }}</td>
                        <td class="text-right pl-0 pr-1">{{ formatNumber(row.item.TotaleAnnoAtt) }}</td>
                        <td class="text-right pl-0 pr-1">{{ formatNumber(row.item.Previsione) }}</td>
                        <td class="pl-0 pr-1" :class="['text-center', getCellClass(row.item.IncTot)]">
                            {{ row.item.IncTot }}
                        </td>
                    </tr>
                </template>
            </v-data-table>
        </v-col>
    </v-container>
</template>

<script>
import { get_trimestre } from "@/api/api.statistiche.js";

export default {
    props: {
        aggiorna: { type: Number, default: 0 },
    },

    data: () => ({
        dati: [],
        anno: new Date().getFullYear(),
        search: "",
        headers: [],
        totAnnoPrec: 0,
        totAnnoAtt: 0,
        raggruppa: false,
    }),


    methods: {
        async caricaDati() {
            this.dati = [];
            this.totAnnoPrec = 0;
            this.totAnnoAtt = 0;
            let res = await get_trimestre("?anno=" + this.anno + "&idAgente=0&raggruppa=" + this.raggruppa);
            this.dati = res.data.Valori;
            this.totAnnoPrec = res.data.TotaleAnnoPrec;
            this.totAnnoAtt = res.data.TotaleAnnoAtt;
            this.aggiornaHeader();
        },

        /* TODO:
        altezza righe sempre fissa a due righe
        esportazione in excel
        percentuale centrata in mezzo (anche il titolo colonna)
        */
        aggiornaHeader() {
            this.headers = [
                { text: "Ragione Sociale", value: "CLRAGSOC", class: "pl-1 pr-1" },
                { text: "Agente", value: "ANNOMAGE", class: "pl-1 pr-1" },
                {
                    text: `${this.anno - 1} 1° Trim`,
                    /* mettere:
                    ANNO
                    nome trimestre */
                    value: "Trimestre_1_Precedente", width: 80
                },
                { text: "%", value: "Inc1", class: "pl-1 pr-1", width: 55 },
                {
                    text: `${this.anno - 1} 2° Trim`,
                    value: "Trimestre_2_Precedente", class: "pl-1 pr-1", width: 80
                },
                { text: "%", value: "Inc2", class: "pl-1 pr-1", width: 55 },
                {
                    text: `${this.anno - 1} 3° Trim`,
                    value: "Trimestre_3_Precedente", class: "pl-1 pr-1", width: 80
                },
                { text: "%", value: "Inc3", class: "pl-1 pr-1", width: 55 },
                {
                    text: `${this.anno - 1} 4° Trim`,
                    value: "Trimestre_4_Precedente", class: "pl-1 pr-1", width: 80
                },
                { text: "%", value: "Inc4", class: "pl-1 pr-1", width: 55 },
                {
                    text: `${this.anno} 1° Trim`,
                    value: "Trimestre_1_Attuale", class: "pl-1 pr-1", width: 80
                },
                { text: "%", value: "Inc5", class: "pl-1 pr-1", width: 55 },
                {
                    text: `${this.anno} 2° Trim`,
                    value: "Trimestre_2_Attuale", class: "pl-1 pr-1", width: 80
                },
                { text: "%", value: "Inc6", class: "pl-1 pr-1", width: 55 },
                {
                    text: `${this.anno} 3° Trim`,
                    value: "Trimestre_3_Attuale", class: "pl-1 pr-1", width: 80
                },
                { text: "%", value: "Inc7", class: "pl-1 pr-1", width: 55 },
                {
                    text: `${this.anno} 4° Trim`,
                    value: "Trimestre_4_Attuale", class: "pl-1 pr-1", width: 80
                },
                { text: "%", value: "Inc8", class: "pl-1 pr-1", width: 55 },
                {
                    text: `Totale ${this.anno - 1}`,
                    value: "TotaleAnnoPrec", class: "pl-1 pr-1"
                },
                {
                    text: `Totale ${this.anno}`,
                    value: "TotaleAnnoAtt", class: "pl-1 pr-1"
                },
                { text: "Previsione", value: "Previsione", class: "pl-1 pr-1" },
                { text: "%", value: "IncTot", class: "pl-1 pr-1" },
            ];
        },

        getCellClassForColumn(column, item) {
            if (column.value === 'Inc1') {
                return 'light-yellow';
            }
            // Colonne "Inc2", "Inc3", ..., "Inc8", "IncTot" (GreenYellow o PeachPuff)
            if (
                ['Inc2', 'Inc3', 'Inc4', 'Inc5', 'Inc6', 'Inc7', 'Inc8', 'IncTot'].includes(column.value)
            ) {
                return this.getCellClass(item[column.value]);
            }
            // Nessuna classe per le altre colonne
            return '';
        },

        getCellClass(value) {
            if (value > 0) {
                return 'green-yellow';
            } else {
                return 'peach-puff';
            }
        },
        getInc1Class() {
            return 'light-yellow';
        },

        formatNumber(value) {
            if (value === null || value === undefined || isNaN(value)) return '';
            return Number(value)
                .toFixed(2)
                .replace('.', ',')
                .replace(/\B(?=(\d{3})+(?!\d))/g, '.');
        }
    },

    watch: {
        aggiorna() {
            this.caricaDati();
        },
    },

    mounted() {
        this.caricaDati();
    },

    computed: {
        variation() {
            if (this.totAnnoPrec === 0) return 0;
            return (((this.totAnnoAtt - this.totAnnoPrec) / this.totAnnoPrec) * 100).toFixed(2);
        },
    }
}
</script>

<style scoped>
.light-yellow {
    background-color: #FFFFCC;
    /* LightYellow */
}

.green-yellow {
    background-color: #C1F0C8;
    /* GreenYellow */
}

.peach-puff {
    background-color: #FBE2D5;
    /* PeachPuff */
}

table td {
    border: 1px solid #ecebeb;
    height: 44px !important;
    max-height: 44px !important;
}

table tr {
    height: 44px !important;
    max-height: 44px !important;
}

.border-style {
    border: 2px solid #ddd;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
</style>